const defaultCtgryDesc =
  'Lorem ipsum, dolor sit amet consectetur adipisicing elit.';

export const categories: any = {
  4: {
    name: 'categories.farmer',
    image: 'https://media.umangapp.in/cdn/landing/theme/category/farmer.svg',
    desc: 'categories.farmer',
  },
  151: {
    name: 'categories.socialSecurity',
    image: 'https://media.umangapp.in/cdn/landing/theme/category/social.svg',
    desc: 'categories.socialSecurity',
  },
  1: {
    name: 'categories.students',
    image: 'https://media.umangapp.in/cdn/landing/theme/category/student.svg',
    desc: 'categories.educationSkillEmployment',
  },
  144: {
    name: 'categories.womenChildren',
    image: 'https://media.umangapp.in/cdn/landing/theme/category/women.svg',
    desc: 'categories.womenChild',
  },
  6: {
    name: 'categories.youthSkillsEmployment',
    image: 'https://media.umangapp.in/cdn/landing/theme/category/youth.svg',
    desc: 'categories.youthSkills',
  },
  143: {
    name: 'categories.certificates',
    image:
      'https://media.umangapp.in/cdn/landing/theme/category/certificates.svg',
    desc: 'categories.eDistrict',
  },
  47: {
    name: 'categories.financeBanking',
    image: 'https://media.umangapp.in/cdn/landing/theme/category/finance.svg',
    desc: 'categories.bfsi',
  },
  3: {
    name: 'categories.health',
    image: 'https://media.umangapp.in/cdn/landing/theme/category/health.svg',
    desc: 'categories.healthWellness',
  },
  87: {
    name: 'categories.policeLegal',
    image: 'https://media.umangapp.in/cdn/landing/theme/category/police.svg',
    desc: 'categories.policeLegal',
  },
  85: {
    name: 'categories.publicGrievance',
    image: 'https://media.umangapp.in/cdn/landing/theme/category/public.svg',
    desc: 'categories.publicGrievance',
  },
  152: {
    name: 'categories.tourismCulture',
    image: 'https://media.umangapp.in/cdn/landing/theme/category/tourism.svg',
    desc: defaultCtgryDesc,
  },
  9: {
    name: 'categories.transport',
    image: 'https://media.umangapp.in/cdn/landing/theme/category/transport.svg',
    desc: 'categories.transport',
  },
  13: {
    name: 'categories.utility',
    image: 'https://media.umangapp.in/cdn/landing/theme/category/utility.svg',
    desc: 'categories.utilityBillPayment',
  },
  148: {
    name: 'categories.general',
    image: 'https://media.umangapp.in/cdn/landing/theme/category/general.svg',
    desc: 'categories.general',
  },
  38: {
    name: 'categories.energy',
    image: 'https://media.umangapp.in/cdn/landing/theme/category/energy.svg',
    desc: defaultCtgryDesc,
  },
  156: {
    name: 'categories.social-justice',
    image:
      'https://media.umangapp.in/cdn/landing/theme/category/social-justice.svg',
    desc: 'categories.socialJustice',
  },
  149: {
    name: 'categories.education',
    image: 'https://media.umangapp.in/cdn/landing/theme/category/education.svg',
    desc: 'categories.EducationSkillEmployment',
  },
  158: {
    name: 'categories.ration-card',
    image:
      'https://media.umangapp.in/cdn/landing/theme/category/ration-card.svg',
    desc: 'categories.meraRation',
  },
  5: {
    name: 'categories.housing',
    image: 'https://media.umangapp.in/cdn/landing/theme/category/housing.svg',
    desc: defaultCtgryDesc,
  },
  84: {
    name: 'categories.revenue',
    image: 'https://media.umangapp.in/cdn/landing/theme/category/revenue.svg',
    desc: defaultCtgryDesc,
  },
  90: {
    name: 'categories.armed-forces',
    image:
      'https://media.umangapp.in/cdn/landing/theme/category/armd-force.svg',
    desc: defaultCtgryDesc,
  },
  163: {
    name: 'categories.indian-railway',
    image: 'https://media.umangapp.in/cdn/landing/theme/category/railway.svg',
    desc: defaultCtgryDesc,
  },
  14: {
    name: 'categories.travel',
    image:
      'https://media.umangapp.in/cdn/landing/theme/category/travel.svg',
    desc: 'categories.travel-desc',
  },
  1000: {
    name: 'categories.dbt',
    image:
      'https://media.umangapp.in/cdn/landing/theme/category/dbt-scheme.svg',
    desc: 'categories.dbt-desc',
  }
  // 1000:{
  //   name: 'categories.dbt',
  //   image: 'https://media.umangapp.in/cdn/dept/umang/category/dbt_Schemes.svg',
  //   desc: defaultCtgryDesc,
  // },
};
